import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CurrencyState {
	currentCurrency: "NOK" | "G";
	setCurrency: (newValue: "NOK" | "G") => void;
	formatCurrency: (number: number, language: "en" | "nb-NO") => string;
}

const useCurrency = create<CurrencyState>()(
	persist(
		(set, get) => ({
			currentCurrency: "NOK",
			setCurrency: (newCurrency) => {
				set({ currentCurrency: newCurrency });
			},
			formatCurrency: (number, language) => {
				const intlLanguage = language === "nb-NO" ? "nb" : "en-US";

				if (get().currentCurrency === "G") {
					return `${new Intl.NumberFormat(intlLanguage, {
						style: "decimal",
						minimumFractionDigits: 0,
					}).format(number)} G`;
				}

				if (language === "nb-NO") {
					return new Intl.NumberFormat(intlLanguage, {
						style: "currency",
						currency: get().currentCurrency,
						minimumFractionDigits: 0,
					}).format(number);
				}

				return new Intl.NumberFormat(intlLanguage, {
					style: "currency",
					currency: get().currentCurrency,
				}).format(number);
			},
		}),
		{
			name: "currency-store",
		}
	)
);

export default useCurrency;
